import { useEffect } from 'react';
import { LINKEDIN_URL, SUPPORT_EMAIL, SUPPORT_PHONE_PRIMARY_DISPLAY } from '@/config/links';

const GlobalStructuredData = () => {
  useEffect(() => {
    const organizationId = 'schema-organization';
    const websiteId = 'schema-website';

    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Boxd Logistics',
      url: 'https://boxdlogistics.in',
      logo: 'https://boxdlogistics.in/logo.jpg',
      contactPoint: [
        {
          '@type': 'ContactPoint',
          contactType: 'customer support',
          email: SUPPORT_EMAIL,
          telephone: SUPPORT_PHONE_PRIMARY_DISPLAY,
          areaServed: 'IN',
          availableLanguage: ['en', 'hi']
        }
      ],
      sameAs: [LINKEDIN_URL]
    };

    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Boxd Logistics',
      url: 'https://boxdlogistics.in',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://boxdlogistics.in/blogs?query={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    };

    const upsertScript = (id, data) => {
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = id;
        document.head.appendChild(script);
      }
      script.text = JSON.stringify(data);
    };

    upsertScript(organizationId, organizationSchema);
    upsertScript(websiteId, websiteSchema);
  }, []);

  return null;
};

export default GlobalStructuredData;
